module.exports = __webpack_public_path__ + "ebd02b42.jpg";